import React, { FunctionComponent } from 'react';
import CheckListItem, { CheckListItemProps } from 'components/check-list/check-list-item';

export type CheckListProps = {
    items: CheckListItemProps[];
};

const CheckList: FunctionComponent<CheckListProps> = ({ items }) => {
    return (
        <ul className="check-list">
            {items.map((item: CheckListItemProps, index: number) => {
                return <CheckListItem key={index} {...item} />;
            })}
        </ul>
    );
};

export default CheckList;
